export const handleCamelToSnake = ({ string = '', upperCase = false }) => {
  const newString = string.replace(/([A-Z])/g, (segment) => {
    return `_${segment}`
  })

  if (upperCase) return newString.toLocaleUpperCase()

  return newString.toLocaleLowerCase()
}
